import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/FormRadioBlockInput.module.scss';

const EnrollmentFormCheckboxBlockInput = ({ name, id, label, value, defaultValue, inputRef, onClick }) => {
  return (
    <label htmlFor={id} className={styles.EnrollmentFormCheckboxBlockInput}>
      <input
        name={name}
        id={id}
        type="checkbox"
        value={value}
        defaultChecked={defaultValue && defaultValue[value]}
        ref={inputRef}
        onClick={onClick}
      />
      <span className={styles.option}>{label}</span>
      <div className={styles.checkedBackground} />
    </label>
  );
};

EnrollmentFormCheckboxBlockInput.defaultProps = {
  defaultValue: null,
  onClick: null,
};

EnrollmentFormCheckboxBlockInput.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  defaultValue: PropTypes.shape({}),
  inputRef: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

export default EnrollmentFormCheckboxBlockInput;
